import { style } from 'typestyle'
export const mt36 = style({ marginTop: '36px' })
